<p>status works!</p>

<div class="status">
    <form class="example-form" [formGroup]="sampleForm">
        <mat-form-field class="example-full-width">
          <input matInput placeholder="Favorite name" (change)="editName($event)" formControlName="name"><!-- value="Sushi" overrides the value from FormControl mtd -->
        </mat-form-field>
    
        <mat-form-field class="example-full-width">
          <textarea matInput formControlName="text" (change)="editText($event)" placeholder="Leave a comment"></textarea>
        </mat-form-field>
      </form>
</div>
